import * as IssueArchive from '../components/IssueArchive';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    IssueArchive.init();
    // TODO remove once year selection is implemented the right way
    $(".page-header--year-selection").click((event)=>{
      // event.preventDefault();
      // alert("Sorry, we are implementing the Year Selection feature. Don't worry, it will be available very soon!");
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateIssuesArchive.js